const API_EDGE_BASE = 'https://api-edge.myfreecams.com'
const getApiUrl = <T extends string>(resource: T) =>
    `${API_EDGE_BASE}/${resource}` as const

export const API_ACCOUNT = getApiUrl('account/self')
export const API_ACTIVITY_LOG_ROOM = getApiUrl('activityLog/roomLog')
export const API_ACTIVITY_LOG_TIPS = getApiUrl('activityLog/tippedModels')
export const API_ARCHIVES = getApiUrl('chatLogs')
export const API_CHANGE_PASSWORD = getApiUrl('account/changePassword')
export const API_DEACTIVATE_ACCOUNT = getApiUrl('account/deactivateAccount')
export const API_LISTS_friends = getApiUrl('lists/friends')
export const API_LISTS_bookmarks = getApiUrl('lists/bookmarks')
export const API_LISTS_ignores = getApiUrl('lists/ignores')
export const API_LISTS_hidden = getApiUrl('lists/hidden_models')
export const API_MANAGE_LISTS = {
    friends: API_LISTS_friends,
    bookmarks: API_LISTS_bookmarks,
    ignores: API_LISTS_ignores,
    hidden: API_LISTS_hidden,
}
export const API_LOGIN = getApiUrl('login')
export const API_MAIL_getMessages = getApiUrl('userMessages')
export const API_MAIL_getMessage = getApiUrl('userMessages/getMessageContents')
export const API_MAIL_getSentMessages = getApiUrl(
    'userMessages/getSentMessages',
)
export const API_MAIL_markMessage = getApiUrl('userMessages/markMessage')
export const API_MAIL_sendMessage = getApiUrl('userMessages/sendMessage')
export const API_MISS_MFC = getApiUrl('missmfc')
export const API_MISS_MFC_HISTORY = getApiUrl('missmfc/year')
export const API_MISS_MFC_MODEL_HISTORY = getApiUrl('missmfc/model')
export const API_MODEL_EXPLORER = getApiUrl('modelExplorer')

/**
 * @deprecated Original API; does not update config. Please use API_MODELS_YOU_MAKE_LIKE_MODELS
 */
export const API_MODELS_YOU_MAKE_LIKE = getApiUrl('recommend')
export const API_MODELS_YOU_MAKE_LIKE_CONFIG = getApiUrl('recommend/config')
export const API_MODELS_YOU_MAKE_LIKE_MODELS = getApiUrl('recommend/models')
export const API_MODELS_YOU_MAY_LIKE_MUTATE = getApiUrl(
    `recommend/model_config`,
)

export const API_MEMBER_WEBCAMS = getApiUrl('memberWebcams')
export const API_MY_WEBCAM = getApiUrl('account/myWebcam')
export const API_MY_WEBCAM_ACCESS_ALLOW = getApiUrl(
    'account/myWebcam/webcam_access_list_allow',
)
export const API_MY_WEBCAM_ACCESS_BLOCK = getApiUrl(
    'account/myWebcam/webcam_access_list_block',
)
export const API_MY_WEBCAM_ACCESS_LIST = getApiUrl(
    'account/myWebcam/webcam_access_list',
)
export const API_NEWS = getApiUrl('newsfeed')
export const API_NEWS_info = getApiUrl('newsfeed/info')
export const API_NOTES_default = getApiUrl('userNotepad')
export const API_NOTES_addUser = getApiUrl('userNotepad/addUser')
export const API_NOTES_prepend = getApiUrl('userNotepad/prepend')
export const API_NOTES_search = getApiUrl('userNotepad/search')
export const API_NOTES_userList = getApiUrl('userNotepad/userList')
export const API_NOTIFICATIONS = getApiUrl('account/notifications')
export const API_PROCESS_VISITOR = getApiUrl('entryPoint/processVisitor')
export const API_PURCHASE_INFO = getApiUrl('purchase/info')
// Segpay's v2 UI (opens via a PayPal popup now)
export const SEGPAY_UI_VERSION = 2
export const API_PURCHASE_INFO_QUERY = `use_jpost=1&segpay_ui_version=${SEGPAY_UI_VERSION}`
export const API_PURCHASE_qualifyPurchase = getApiUrl(
    'purchase/qualify_purchase',
)
export const API_PURCHASE_quickBuy = getApiUrl('purchase/quickbuy')
export const API_REPORT_USER = getApiUrl('reportUser')
export const API_REQUIRED_CHANGE_REASON = getApiUrl(
    'account/getRequiredChangeReasons',
)
export const API_REQUIRED_CHANGES_SUBMIT = getApiUrl('account/change')
export const API_RULE_VIOLATION = getApiUrl('account/confirmRuleViolation')
export const API_SEARCH_groupShows = getApiUrl('groupShows')
export const API_SEARCH_trendingRooms = getApiUrl('trendingRooms?lookback=60')
export const API_SIGNUP = getApiUrl('signup')
export const API_SIGNUP_RANDOM_USERNAME = getApiUrl('signup/getRandomUsername')
export const API_SIGNUP_validate = getApiUrl('account/qualifyUserPass')
export const API_SOCIAL_MEDIA = getApiUrl('social_media')
export const API_TAGS = getApiUrl('tags/models')
export const API_TAGS_TOPICS = getApiUrl('topics')
export const API_TIP = getApiUrl('tip')
export const API_TIP_DEFAULTS = getApiUrl('tip/defaults')
export const API_TIP_SET_DEFAULTS = getApiUrl('tip/setDefaults')
export const API_TOKEN = getApiUrl('token')
export const API_TOKEN_USAGE = getApiUrl('account/tokenUsage')
export const API_TOKEN_STORAGE = getApiUrl('account/shiftTokenStorage')
export const API_USER_EXTENSIONS = getApiUrl('ue/')
export const API_UE_PRIVACY_tokens = getApiUrl('ue/token_reveal_level')
export const API_UE_PRIVACY_points = getApiUrl('ue/rp_reveal_level')
export const API_UE_EMAILS_administrative = getApiUrl(
    'ue/administrative_emails',
)
export const API_UE_EMAILS_purchaseConfirmation = getApiUrl(
    'ue/purchase_confirmation_emails',
)
export const API_UE_BROADCASTING_NOTIFICATION_browser = getApiUrl(
    'ue/disable_model_browser_notification',
)
export const API_UE_BROADCASTING_NOTIFICATION_email = getApiUrl(
    'ue/disable_model_email_notification',
)
export const API_UE_BROADCASTING_NOTIFICATION_sound = getApiUrl(
    'ue/disable_model_sound_notification',
)
export const API_UE_CHAT_TEXT_COLOR = getApiUrl('ue/chat_text_color')
export const API_UE_PM_NOTIFICATION = getApiUrl('ue/notification_pm')
export const API_UE_PRIVATES_gallery = getApiUrl('ue/exclusive_gallery_opt_out')
export const API_UE_PRIVATES_truePrivate = getApiUrl('ue/true_private')
export const API_UE_disableInChatQuickbuy = getApiUrl(
    'ue/disable_in_chat_quickbuy',
)
export const API_USER_CHAT_IMAGES = getApiUrl('user_chat_images')
export const API_VIDEO_AVATARS = getApiUrl('video_avatars')
export const API_VIDEO_AVATARS_ALL = getApiUrl('video_avatars/all')
export const API_VIDEO_AVATARS_ONLINE = getApiUrl('video_avatars/online')

export const CONTACT_SUPPORT_POST_ENDPOINT = `https://www.myfreecams.com/php/formmail.php`
export const FEEDBACK_URL = `/api/parseFeedback`
export const MANAGE_LISTS_URL = `https://www.myfreecams.com/php/manage_lists2.php`
export const PARSE_CHAT_STREAM_API = `https://www.myfreecams.com/php/ParseChatStream.php`
export const SHARE_TIP_ENDPOINT =
    'https://share.myfreecams.com/api/v1/chat_commands/sharetip'

export const API_MODEL_USERNAME_LOOKUP = getApiUrl(
    'utility/modelUsernameLookup',
)

// internal APIs; requests must be made on the server
export const API_INTERNAL_PROCESS_VISITOR =
    'https://api.myfreecams.com/internal/entryPoint/processVisitor'
export const API_INTERNAL_USER_LOOKUP =
    'https://api.myfreecams.com/internal/v2/user_lookup'
export const API_INTERNAL_USER_PROFILE =
    'https://api.myfreecams.com/user_profile'
export const API_INTERNAL_REGION_BLOCK =
    'https://api.myfreecams.com/internal/regionBlock'
// honors the visitor's `ip_address` for internal callers; the edge host
// serves the public, requester-filtered feed
export const API_INTERNAL_ONLINE_MODELS =
    'https://api.myfreecams.com/online_models'
